import React from 'react';
import { SingleCollapse } from "@/components/";
import Activities from './activities';
import Results from './results';

interface IExpectedResults{
    id: number;
    status: any;
    screen?: string;
    results: any;
    activities: any;
	dataColumns: any;
    currentYear: any;
    saveTable: any;
    tableAlerts?: string;
    initialValidate: boolean;
    initialValidateActPlan?: boolean;
    dimensionData?: any;
}

const ExpectedResults: React.FC<IExpectedResults> = ({results, tableAlerts, activities, status, screen, dataColumns, id, currentYear, saveTable, initialValidate, dimensionData, initialValidateActPlan}: IExpectedResults) => {

    const renderExpectedResult = (data:any, status:any) => {
		data = data.filter((x: any) => x.idParent === id)

        const result = data.map((result:any, index:number) => {            
            return (
                <SingleCollapse
                    keepOpen={!!tableAlerts}
                    key={index}
                    title={result.staticTitle}
                    description={result.name}
                    isOpen={(tableAlerts === "All" || initialValidate || initialValidateActPlan) ? true : false}
                >
                    <Results
                        initialValidate={initialValidate}
                        tableAlerts={tableAlerts} 
                        id={result.id}
                        index={index}
                        status={status}
                        screen={screen}
                        dataColumns={dataColumns} 
                        result={result} 
                        currentYear={currentYear} 
                        saveTable={saveTable}
                    />
                    <Activities 
                        initialValidate={initialValidate}
                        initialValidateActPlan={initialValidateActPlan}
                        tableAlerts={tableAlerts} 
                        id={result.id} 
                        index={index} 
                        status={status} 
                        screen={screen} 
                        dataColumns={dataColumns} 
                        activities={activities} 
                        currentYear={currentYear} 
                        saveTable={saveTable}
                        dimensionData={dimensionData} 
                    />
                </SingleCollapse>
            );        
        });
        return result;
    }

    if(!results?.length || !status) return <></>;
    return renderExpectedResult(results, status);
}
export default ExpectedResults;